import React from 'react'
import { pageHeaderStyle } from '../../components/Helper'
import { Typography } from '@mui/material'
interface propsType {

}

const ComingSoonComponent = (props:propsType) => {
    return (
        <>
            <Typography style={pageHeaderStyle} variant="h3" gutterBottom sx={{ display: "inline" }}>
               Coming soon!
            </Typography>
        </>
    )
}

export default ComingSoonComponent